import { cn } from "@/lib/utils";
import { forwardRef } from "react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = forwardRef<
  HTMLInputElement,
  InputProps & {
    prefixs?: React.ReactNode;
    suffix?: React.ReactNode;
    required?: boolean;
    inputSize?: "sm" | "md";
  }
>(
  (
    {
      className,
      type,
      suffix,
      prefixs,
      placeholder,
      required,
      inputSize = "md",
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={cn(
          "group relative flex h-10 bg-white w-full items-center overflow-hidden rounded border-b border-[#F0F0F0] hover:border-[#FF5100] focus:border-[#FF5100] md:border md:border-[#C2C6CE] md:px-4",
          {
            "h-8": inputSize === "sm",
          }
        )}>
        {prefixs}
        <div className="relative h-full w-full flex-1">
          <input
            type={type}
            className={cn(
              "h-full w-full text-sm outline-none placeholder:text-[#E5E5E5] disabled:bg-transparent disabled:text-[#E5E5E5]",
              className
            )}
            ref={ref}
            {...props}
          />

          {placeholder && !props.value && (
            <span
              className={cn(
                "pointer-events-none absolute left-1 top-1/2 z-10 -translate-y-1/2 text-sm text-[#A6A6A6] after:pl-0.5 after:text-[#FF5100] md:text-[#E5E5E5]",
                required ? "after:content-['*']" : ""
              )}>
              {placeholder}
            </span>
          )}
        </div>
        {suffix}
      </div>
    );
  }
);
Input.displayName = "Input";

export default Input;
